import { useSelector } from 'react-redux';
import { RootState } from 'store';

export function WelcomeHero() {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="space-y-6 px-6 lg:px-0">
      <span className="flex items-center gap-2">
        <img src={isDarkMode ? '/blogwriter-dark.png' : '/blogwriter.png'} />
      </span>
      <div className="space-y-5">
        <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px] md:max-w-[320px]">
          Welcome to Blog Writer
        </h1>
        <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[360px] mb-6 lg:mb-0">
          Discover a free AI blog writer tool that creates engaging and
          well-written articles effortlessly. Boost your content creation
          process and quality today!
        </p>
      </div>
    </div>
  );
}
